export interface IPlacesAutocompleteResult {
  city: string;
  country: string;
  fullName: string;
}
